
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSleetShowersDayColour as ObiLightSleetShowersDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-sleet-showers-day-colour.js';
 
 
 

 
 export const ObiLightSleetShowersDayColour = createComponent({
   react: React,
   tagName: 'obi-light-sleet-showers-day-colour',
   elementClass: ObiLightSleetShowersDayColourElement,
   events: {
     
   }
  });
 
 